import { Box, Button, TextField, Typography } from "@mui/material"
import { useState } from "react"
import { getConfiguration } from "../clients/configuration"
import { GlobalOptOutsApi } from "../clients"
import { AppAlert } from "../components/AppAlerts/AppAlerts"
import { addAlertWithTimeout } from "../redux/features/alerts/alertsHelpers"
import { useAppDispatch } from "../redux/hooks"

export const EmailUnsubscribe = () => {

    const dispatch = useAppDispatch()
    const [email, setEmail] = useState<string>('')
    const [emailError, setEmailError] = useState<string>('')
    const [submitting, setSubmitting] = useState<boolean>(false)
    const [success, setSuccess] = useState<boolean>(false)

    const handleEmailBlur = (): string => {
        const emailRegex = new RegExp(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g)
        if (!email.match(emailRegex)?.length) {
            const error = 'Invalid email address'
            setEmailError(error)
            return error
        }
        return ''
    }

    const handleUnsubscribe = async () => {
        setSubmitting(true)
        const config = await getConfiguration()
        const globalOptOutApi = new GlobalOptOutsApi(config)
        globalOptOutApi.createEmailOptOut({
            endpoint: email,
        }).then(() => {
            setSuccess(true)
        }).catch(() => {
            const appAlert = new AppAlert('error', 'There was an error unsubscribing')
            addAlertWithTimeout(dispatch, appAlert)
            setSubmitting(false)
        })
    }

    if (success) {
        return (
            <Box>
                <Typography variant="h3" sx={{ fontWeight: 200, mt: 3, display: 'block', textAlign: 'center', fontSize: '1.5rem' }}>Email Unsubscribe</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', width: '100%', mt: 3, px: { xs: 3, sm: 6, md: 12 } }}>
                    <Typography variant="body1" sx={{ textAlign: 'center' }}>You have successfully unsubscribed from our emails</Typography>
                </Box>
            </Box>
        )
    }

    return (
        <Box>
            <Typography variant="h3" sx={{ fontWeight: 200, mt: 3, display: 'block', textAlign: 'center', fontSize: '1.5rem' }}>Email Unsubscribe</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', width: '100%', mt: 3, px: { xs: 3, sm: 6, md: 12 } }}>
                <TextField
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    error={!!emailError}
                    helperText={emailError || 'Email Address'}
                    onBlur={handleEmailBlur}
                    onFocus={() => setEmailError('')}
                />
                <Button variant="contained" sx={{ mt: 3 }} disabled={!email || !!emailError || submitting} onClick={handleUnsubscribe}>Unsubscribe</Button>
            </Box>
        </Box>
    )
}